// src/pages/PaymentHistoryPage.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
// Import Header and Footer from HomePage based on available exports
import { Footer } from '../components/HomePage';
// Import the actual components available in your project
// If Header is not available in HomePage, you might need to adjust this
import { Header } from '../components/HomePage';
import Payment from '../components/MyProfile/Payment/Payment';

function PaymentHistoryPage() {
  return (
    <>
      <Helmet>
        <title>Payment History | Circledin</title>
        <meta name="description" content="Manage your payments, subscriptions, and billing details" />
      </Helmet>
      
      
      
      <main className="main-content payment-history-container">
        <Payment />
      </main>
      
      <Footer />
    </>
  );
}

export default PaymentHistoryPage;